module.exports = __webpack_public_path__ + "static/dashboard-iPhone-3e4af3960005c787bdccb986af302cca.png";